import { getCurrentInstance } from "@vue/composition-api";
import { matchesAcl } from "@core/libs/acl/utils";

const useProxy = () => {
  const { proxy } = getCurrentInstance();

  return {
    can: (action, subject) =>
      proxy.$can
        ? matchesAcl(
            (currentAction, currentSubject) =>
              proxy.$can(currentAction, currentSubject),
            action,
            subject,
          )
        : true,
    refs: proxy.$refs,
    route: proxy.$route,
    router: proxy.$router,
    store: proxy.$store,
  };
};

export default useProxy;
